module.exports = __webpack_public_path__ + "static/media/1californiart43.68dae0df.jpg";